import ListController from "vamos/cockpit/base/controller/ListController";
import { SearchField$SearchEvent } from "sap/m/SearchField";
import Table from "sap/ui/table/Table";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListHandler from "vamos/cockpit/base/handler/ListHandler";
import JSONModel from "sap/ui/model/json/JSONModel";
import Service from "vamos/cockpit/data/import/history/Service";
import { ImportRequestLog } from "vamos/cockpit/model/odata/VamosModel";
import Press from "sap/ui/test/actions/Press";
import Button, { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace vamos.cockpit
 */

export default class ImportHistoryListController extends ListController {

  protected _sEntitySet = "ImportRequestLog";
  protected _sMainTableId = "importHistoryListTable";
  protected _oDefaultVariantContext: any = {
    importHistoryListTable: {
      conditions: { "*RequestNumber*": { $search: null } },
      sorters: { Time: "Descending" },
      filters: {},
      width: {},
      states: {},
    },
  };

  protected viewModel: JSONModel = new JSONModel({});

  private listHandler: ListHandler;

  public onInit() {
    super.onInit();

    this.getView().setModel(this.viewModel, "view");
    const table: Table = this.getView().byId(this._sMainTableId) as Table;
    this.listHandler = new ListHandler(table, this.viewModel);
  }

  public onSearchImport(event: SearchField$SearchEvent) {
    const table: Table = this.getView().byId(this._sMainTableId) as Table;

    const binding = table.getBinding("rows") as ODataListBinding;
    binding.filter(new Filter({
      path: "RequestNumber",
      operator: FilterOperator.Contains,
      value1: event.getParameter("query"),
      caseSensitive: false,
    }));
  }

  public async onDownloadMultipleRequests() {
    const selectedContexts = this.listHandler.getSelectedContext();

    if (selectedContexts.length === 1) {
      await Service.downloadFile(selectedContexts[0].getObject() as ImportRequestLog);
      return;
    }

    const guids: string[] = selectedContexts.map((context) => context.getProperty("Guid") as string);
    await Service.downloadFiles(guids);
  }

  public async onDownloadRequest(event: Button$PressEvent) {
    const button: Button = event.getSource();
    const context = button.getBindingContext();
    await Service.downloadFile(context.getObject() as ImportRequestLog);
  }
}